import * as React from "react";
import { Link } from "react-router-dom";

import { PageExternal } from "@pro/containers/PageExternal";

import { IconChevronLeft } from "@common/components/Atoms/Icons";
import { IconLogoMark } from "@common/components/Atoms/Icons";
import { GlobalConfig } from "@common/utils/config";

/*===========================================================================
  Account Page
/*======================================================================== */
interface AccountPageProps {
    title: string
    message?: string
    back?: string
    children?: React.ReactNode
    backFunc?: () => void
    pageTitle?: string
    hideLogo?: boolean
    updating: boolean
};


export const AccountPage: React.SFC<AccountPageProps> = (props: AccountPageProps) => {
    const logo = !!props.hideLogo ? null : (
        <div title={GlobalConfig.version} className="c-account__logo">
            <IconLogoMark />
        </div>
    );

    return (
        <PageExternal updating={props.updating} updatingMessage="please wait" title={props.pageTitle ? props.pageTitle : ""}>
            <section className="c-account">
                {props.back && (
                    <section className="c-account__back">
                        <Link to={props.back}>
                            <IconChevronLeft />back
                    </Link>
                    </section>
                )}
                {props.backFunc && (
                    <section className="c-account__back">
                        <span className="c-button--flat" onClick={props.backFunc} >
                            <IconChevronLeft />back
                    </span>
                    </section>
                )}
                <section className="c-account__header">
                    {logo}
                    <h1 className="c-account__title">{props.title}</h1>
                    <p className="c-account__message">{props.message}</p>
                </section>
                <section className="c-account__body">{props.children}</section>
            </section>
        </PageExternal>
    )
}

export default AccountPage;
